import apiHandler from "../core/apiHandler";

const userProfileApi = apiHandler('user-config');
export default userProfileApi;
